import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderBrandUpdatePage = lazy(() => import('../views/update/ProviderBrandUpdatePage'));

export function ProviderBrandUpdatePageLazy() {
	return (
		<PageSuspense>
			<ProviderBrandUpdatePage />
		</PageSuspense>
	);
}
